export { GtmConsentSync } from './GtmConsentSync'
